import Index from '../../pages/tideng/anniversary/index';
import Help from '../../pages/tideng/anniversary/help';

const base = 'anniversary';

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
  {
    path: `/${base}/help*`,
    name: `${base}-help`,
    component: Help
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/tideng/anniversary.js